import { Formik } from "formik";
import * as yup from "yup";
import React, { Component } from "react";
import { Modal, Button, Form, Row, Col, Spinner } from "react-bootstrap";
import { RenderSelectInput, RenderTextInput } from "app/common/renderInput";
import { NotificationManager } from "react-notifications";
import { addMarkUp } from "app/services/markUpService";
import { useState } from "react";
import { useEffect } from "react";

const markupSchema = yup.object().shape({
  markupName: yup.string().required("Markup Name is required"),
  markupDescription: yup.string().required("Markup Description is required"),
  domesticMarkup: yup
    .string()
    .required("Domestic Markup is required")
    .matches(/^\d*\.?\d*$/, "Domestic Markup should be Number "),

  internationalMarkup: yup
    .string()
    .required("International Markup is required")
    .matches(/^\d*\.?\d*$/, "International Markup should be Number "),
  isActive: yup.boolean().required("status is required!"),
  isDefault: yup.boolean(),
});

function MarkupModal({ handleClose, handleShow, editId, show, editRow }) {
  const [isShow, setIsShow] = useState(false);
  const markup = {
    markupName: "",
    markupDescription: "",
    domesticMarkup: "",
    internationalMarkup: "",
    isDefault: false,
    isActive: true,
  };
  const [state, setState] = useState(markup);

  const statusOptions = [
    { value: "true", label: "Active" },
    { value: "false", label: "Inactive" },
  ];

  const handleSubmit = async (values) => {
    setIsShow(true);
    const response = await addMarkUp(values);
    try {
      if (response.status === "Success") {
        if (values.id > 0) {
          NotificationManager.success("MarkUp  Update successfully");
        } else {
          NotificationManager.success("MarkUp Add successfully");
        }

        document.querySelectorAll(".btn-close")[0].click();
        setIsShow(false);
      } else {
        NotificationManager.success("Something went wrong");
        document.querySelectorAll(".btn-close")[0].click();
        setIsShow(false);
      }
    } catch (error) {
      NotificationManager.error("something went to be wrong");
      document.querySelectorAll(".btn-close")[0].click();
      setIsShow(false);
      console.log(error);
      throw error;
    }
  };

  useEffect(() => {
    if (editRow) {
      setState(editRow);
    } else {
      setState(markup);
    }
  }, [editRow]);

  return (
    <div>
      <Formik
        initialValues={state}
        validationSchema={markupSchema}
        enableReinitialize={true}
        onSubmit={handleSubmit}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting,
        }) => (
          <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
              <Modal.Title>
                {values.id > 0 ? "Update MarkUp" : "Add MarkUp"}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <form onSubmit={handleSubmit} className="p-3">
                <Form.Group className="mb-3">
                  <RenderTextInput
                    type="text"
                    display="Markup Name"
                    placeholder="Enter Markup Name"
                    name="markupName"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.markupName}
                    error={errors.markupName}
                    autoComplete="off"
                    touched={touched.markupName}
                    required
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <RenderTextInput
                    type="text"
                    display="Markup Description"
                    placeholder="Enter Markup Description"
                    name="markupDescription"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    autoComplete="off"
                    error={errors.markupDescription}
                    value={values.markupDescription}
                    touched={touched.markupDescription}
                    required
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <RenderTextInput
                    type="text"
                    display="Domestic Markup"
                    placeholder="Enter Domestic Markup"
                    name="domesticMarkup"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    autoComplete="off"
                    error={errors.domesticMarkup}
                    value={values.domesticMarkup}
                    touched={touched.domesticMarkup}
                    required
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <RenderTextInput
                    type="text"
                    display="International Markup"
                    placeholder="Enter International Markup"
                    name="internationalMarkup"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={errors.internationalMarkup}
                    value={values.internationalMarkup}
                    autoComplete="off"
                    touched={touched.internationalMarkup}
                    required
                  />
                </Form.Group>
                <Form.Group>
                  <RenderSelectInput
                    disabled={values.isDefault === true}
                    type="text"
                    display="Status"
                    name="isActive"
                    value={values.isActive}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={errors.isActive}
                    touched={touched.isActive}
                    items={statusOptions}
                    required
                  ></RenderSelectInput>
                </Form.Group>

                <Row>
                  <div className="m-auto text-center">
                    {isShow ? (
                      <Button variant="primary" size="md" disabled>
                        <Spinner
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                          style={{ marginRight: "10px" }}
                        />
                        {values.id > 0 ? "Updating..." : "Adding..."}
                      </Button>
                    ) : (
                      <Button variant="primary" size="md" type="submit">
                        {values.id > 0 ? "Update Markup" : "Add Markup"}
                      </Button>
                    )}
                  </div>
                </Row>
              </form>
            </Modal.Body>
          </Modal>
        )}
      </Formik>
    </div>
  );
}

export default MarkupModal;
